import { render, staticRenderFns } from "./excluirAtividadeDialog.vue?vue&type=template&id=153dd2ab"
import script from "./excluirAtividadeDialog.vue?vue&type=script&lang=js"
export * from "./excluirAtividadeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports